function helperStringLowerCase (str) {
  return str.toLowerCase()
}

module.exports = helperStringLowerCase
